import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../redux/store';
import { updateUserData } from '../redux/slices/userSlice';
import { calculateNextBillingDate } from '../utils/planUpgrade';

export const useSubscriptionRenewal = () => {
  const dispatch = useDispatch();
  const userData = useSelector((state: RootState) => state.user.data);
  const [showRenewalAlert, setShowRenewalAlert] = useState(false);
  const [daysUntilRenewal, setDaysUntilRenewal] = useState<number | null>(null);

  useEffect(() => {
    const cycleEnd = userData.currentCycleEnd;
    if (typeof cycleEnd !== 'string' || userData.plan === 'Free') {
      setShowRenewalAlert(false);
      setDaysUntilRenewal(null);
      return;
    }

    const checkRenewalDate = () => {
      const cycleEndDate = new Date(cycleEnd);
      const today = new Date();
      const days = Math.ceil((cycleEndDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
      
      setDaysUntilRenewal(days);
      setShowRenewalAlert(days <= 7 && days > 0);
    };

    // Verifica imediatamente
    checkRenewalDate();

    // Configura um intervalo para verificar a cada hora
    const interval = setInterval(checkRenewalDate, 1000 * 60 * 60);

    return () => clearInterval(interval);
  }, [userData.currentCycleEnd, userData.plan]);

  const handleRenewal = async () => {
    try {
      const cycleEnd = userData.currentCycleEnd;
      if (typeof cycleEnd !== 'string') {
        throw new Error('Data de fim do ciclo não encontrada');
      }

      // Simula uma chamada de API para processar a renovação
      await new Promise(resolve => setTimeout(resolve, 1000));

      // Atualiza a data de fim do ciclo para o próximo mês
      const nextBillingDate = calculateNextBillingDate(cycleEnd);

      // Atualiza os dados do usuário
      dispatch(updateUserData({
        currentCycleEnd: nextBillingDate
      }));

      // Esconde o alerta
      setShowRenewalAlert(false);
    } catch (error) {
      console.error('Erro ao renovar assinatura:', error);
      // Aqui você pode adicionar uma notificação de erro se desejar
    }
  };

  return {
    showRenewalAlert,
    daysUntilRenewal,
    handleRenewal,
    setShowRenewalAlert
  };
}; 